let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9qtM6")).then(() => parcelRequire('9Xezc'));